// extracted by mini-css-extract-plugin
export var growableInput = "_7g-0";
export var tagContainer = "_7g-2";
export var textInput = "_7g-1";